let routes = [{
  path: "/",
  redirect: "/index"
},
{
  path: '/index',
  name: 'index',
  component: () => import('@/views/page/home') // 首页
},
{
  path: '/test',
  name: 'test',
  component: () => import('@/views/template/test') 
},
{
  path: '/notice',
  name: 'notice',
  component: () => import('@/views/page/notice') // 通知公告
},
{
  path: '/notice/detail',
  name: 'noticedetail',
  component: () => import('@/views/page/notice/detail') // 通知公告详情
},
{
  path: '/alliance',
  name: 'alliance',
  component: () => import('@/views/page/alliance') // 产业联盟
},
{
  path: '/alliance2',
  name: 'alliance2',
  component: () => import('@/views/page/alliance') // 产业联盟
},
{
  path: '/alliance3',
  name: 'alliance3',
  component: () => import('@/views/page/alliance') // 产业联盟
},
{
  path: '/alliance4',
  name: 'alliance4',
  component: () => import('@/views/page/alliance') // 产业联盟
},
{
  path: '/industry',
  name: 'industry',
  component: () => import('@/views/page/industry') // 产业动态
},
{
  path: '/industry/detail',
  name: 'industrydetail',
  component: () => import('@/views/page/industry/detail') // 产业动态详情
},
//end
{
  path: '/policy',
  name: 'policy',
  component: () => import('@/views/page/policy') // 政策指南
},
{
  path: '/policy/detail',
  name: 'policydetail',
  component: () => import('@/views/page/policy/detail') // 政策指南详情
},
{
  path: '/iprsell',
  name: 'iprsell',
  component: () => import('@/views/page/iprsell') // 专利交易
},
{
  path: '/iprsell/detail',
  name: 'iprselldetail',
  component: () => import('@/views/page/iprsell/detail') // 专利交易详情
},

{
  path: '/pledge',
  name: 'pledge',
  component: () => import('@/views/page/pledge') // 质押融资产品
},
{
  path: '/pledge/detail',
  name: 'pledge',
  component: () => import('@/views/page/pledge/detail') // 质押融资产品详情
},
{
  path: '/pledgepolicy',
  name: 'pledgepolicy',
  component: () => import('@/views/page/pledgepolicy') // 质押融资政策
},
{
  path: '/pledgepolicy/detail',
  name: 'pledgepolicy',
  component: () => import('@/views/page/pledgepolicy/detail') // 质押融资政策详情
},
{
  path: '/evaluate',
  name: 'evaluate',
  component: () => import('@/views/page/evaluate') // 专利分级评价
},
{
  path: '/activity',
  name: 'activity',
  component: () => import('@/views/page/activity') // 活动中心
},
{
  path: '/activity/detail',
  name: 'activity',
  component: () => import('@/views/page/activity/detail') // 活动中心详情
},
{
  path: '/exper',
  name: 'exper',
  component: () => import('@/views/page/exper') // 专家智库
},
{
  path: '/partner',
  name: 'partner',
  component: () => import('@/views/page/partner') // 合作伙伴
},
{
  path: '/train',
  name: 'train',
  component: () => import('@/views/page/train') // 在线培训
},
{
  path: '/train/detail',
  name: 'train',
  component: () => import('@/views/page/train/detail') // 在线培训详情
},
{
  path: '/problem',
  name: 'problem',
  component: () => import('@/views/page/problem') // 知识问答
},
{
  path: '/problem/detail',
  name: 'problem',
  component: () => import('@/views/page/problem/detail') // 知识问答详情
},
{
  path: '/about',
  name: 'about',
  component: () => import('@/views/page/about') // 联系我们
},
{
  path: '/navigation',
  name: 'navigation',
  component: () => import('@/views/page/navigation') // 导航服务
},
{
  path: '/agencyservice',
  name: 'agencyservice',
  component: () => import('@/views/page/agencyservice') // 知产服务
},
{
  path: '/agencyservice/detail',
  name: 'agencyservice',
  component: () => import('@/views/page/agencyservice/detail') // 知产服务详情
},
{
  path: '/aireport',
  name: 'aireport',
  component: () => import('@/views/page/alreport') // 数据可视化
},
{
  path: '/login',
  name: 'login',
  component: () => import('@/views/page/login/login') //
},
{
  path: '/register',
  name: 'register',
  component: () => import('@/views/page/login/register') //
},
{
  path: '/resetpwd',
  name: 'resetpwd',
  component: () => import('@/views/page/login/resetpwd') //
},
{
  path: '/patent/simpleSearch',
  component: () => import('@/views/patent/search/simpleSearch.vue'),//简单检索
  name: 'simpleSearch',
},
{
  path: '/patent/advancedSearch',
  component: () => import('@/views/patent/search/advancedSearch.vue'),//高级检索
  name: 'advancedSearch',
},
{
  path: '/patent/myLabel',
  component: () => import('@/views/patent/search/myLabel.vue'),//我的标引
  name: 'myLabel',
},
{
  path: '/patent/navigationSearch',
  component: () => import('@/views/patent/database/navigationSearch.vue'),//分类检索
  name: 'navigationSearch',
},
{
  path: '/patent/IPCSearch',
  component: () => import('@/views/patent/database/IPCSearch.vue'),//IPC检索
  name: 'IPCSearch',
},
{
  path: '/patent',
  name: 'patent',
  component: () => import('@/views/patent/index'), //专利检索系统
  redirect: "/patent/search/simpleSearch",
  children: [
  ]
},
{
  path: '/patent/analysis/index',
  name: 'analysisIndex',
  component: () => import('@/views/patent/analysis/index.vue'), //新专利分析版块
  redirect: "analysisIndex.vue",
  children: [
    {
      path: '/patent/applyline',
      name: 'applylineN',
      component: () => import('@/views/patent/analysis/applyLine.vue') // 专利申请趋势分析
    },
    {
      path: '/patent/pubLine',
      name: 'pubLineN',
      component: () => import('@/views/patent/analysis/pubLine.vue') // 专利公开趋势分析
    },
    {
      path: '/patent/applyandpubLine',
      name: 'applyandpubLineN',
      component: () => import('@/views/patent/analysis/applyAndPubLine.vue') // 专利申请公开趋势分析
    },
    {
      path: '/patent/pubrateline',
      name: 'pubratelineN',
      component: () => import('@/views/patent/analysis/pubRateLine.vue') // 公开数量增长率
    },
    {
      path: '/patent/ipcbar',
      name: 'ipcbarN',
      component: () => import('@/views/patent/analysis/ipcBar.vue') // 技术构成
    },
    {
      path: '/patent/ipcoverlapbar',
      name: 'ipcoverlapbarN',
      component: () => import('@/views/patent/analysis/ipcOverlapBar.vue') // 技术全球分布
    },
    {
      path: '/patent/ipccityBar',
      name: 'ipccityBarN',
      component: () => import('@/views/patent/analysis/ipcCityBar.vue') // 技术中国省市分布
    },
    {
      path: '/patent/ipccity2Bar',
      name: 'ipccity2BarN',
      component: () => import('@/views/patent/analysis/ipcCity2Bar.vue') // 技术中国城市分布
    },
    {
      path: '/patent/apppeopletopbar',
      name: 'apppeopletopbarN',
      component: () => import('@/views/patent/analysis/apppeopleTopBa.vue') // 申请人排名
    },
    {
      path: '/patent/apppeopletypebar',
      name: 'apppeopletypebarN',
      component: () => import('@/views/patent/analysis/apppeopleTypeBar.vue') // 申请人专利类别
    }
  ]
},
{
  path: '/system',
  name: 'system',
  component: () => import('@/views/system/index'), //管理后台
  redirect: '/system/syshome',
  children: [
    {
      path: '/system/syshome',
      component: () => import('@/views/system/home'),
      name: 'syshome'
    },
    {
      path: '/system/noticeManage',
      component: () => import('@/views/system/noticeManagement/notice.vue'),
      name: 'noticeManage',
    },
    {
      path: '/system/noticeSave',
      component: () => import('@/views/system/noticeManagement/noticeSave.vue'),
      name: 'noticeSave'
    },
    {
      path: '/system/noticeEdit',
      component: () => import('@/views/system/noticeManagement/noticeEdit.vue'),
      name: 'noticeEdit'
    },
    {
      path: '/system/policyManage',
      component: () => import('@/views/system/policyManagement/policy.vue'),
      name: 'policyManage',
    },
    {
      path: '/system/policySave',
      component: () => import('@/views/system/policyManagement/policySave.vue'),
      name: 'policySave'
    },
    {
      path: '/system/policyEdit',
      component: () => import('@/views/system/policyManagement/policyEdit.vue'),
      name: 'policyEdit'
    },
    {
      path: '/system/industryManage',
      component: () => import('@/views/system/industryManagement/industry.vue'),
      name: 'industryManage',
    },
    {
      path: '/system/industrySave',
      component: () => import('@/views/system/industryManagement/industrySave.vue'),
      name: 'industrySave'
    },
    {
      path: '/system/industryEdit',
      component: () => import('@/views/system/industryManagement/industryEdit.vue'),
      name: 'industryEdit'
    },
    {
      path: '/system/pledgeManage',
      component: () => import('@/views/system/pledgeManagement/pledge.vue'),
      name: 'pledgeManage',
    },
    {
      path: '/system/pledgeSave',
      component: () => import('@/views/system/pledgeManagement/pledgeSave.vue'),
      name: 'pledgeSave'
    },
    {
      path: '/system/pledgeEdit',
      component: () => import('@/views/system/pledgeManagement/pledgeEdit.vue'),
      name: 'pledgeEdit'
    },
    {
      path: '/system/tradeManage',
      component: () => import('@/views/system/tradeManagement/trade.vue'),
      name: 'tradeManage',
    },
    {
      path: '/system/tradeSave',
      component: () => import('@/views/system/tradeManagement/tradeSave.vue'),
      name: 'tradeSave'
    },
    {
      path: '/system/tradeEdit',
      component: () => import('@/views/system/tradeManagement/tradeEdit.vue'),
      name: 'tradeEdit'
    },
    {
      path: '/system/trainManage',
      component: () => import('@/views/system/trainManagement/train.vue'),
      name: 'trainManage',
    },
    {
      path: '/system/trainSave',
      component: () => import('@/views/system/trainManagement/trainSave.vue'),
      name: 'trainSave'
    },
    {
      path: '/system/trainEdit',
      component: () => import('@/views/system/trainManagement/trainEdit.vue'),
      name: 'trainEdit'
    },
    {
      path: '/system/expertManage',
      component: () => import('@/views/system/expertManagement/expert.vue'),
      name: 'expertManage',
    },
    {
      path: '/system/expertSave',
      component: () => import('@/views/system/expertManagement/expertSave.vue'),
      name: 'expertSave'
    },
    {
      path: '/system/expertEdit',
      component: () => import('@/views/system/expertManagement/expertEdit.vue'),
      name: 'expertEdit'
    },
    {
      path: '/system/activityManage',
      component: () => import('@/views/system/activityManagement/activity.vue'),
      name: 'activityManage',
    },
    {
      path: '/system/activitySave',
      component: () => import('@/views/system/activityManagement/activitySave.vue'),
      name: 'activitySave'
    },
    {
      path: '/system/activityEdit',
      component: () => import('@/views/system/activityManagement/activityEdit.vue'),
      name: 'activityEdit'
    },
    {
      path: '/system/partnerManage',
      component: () => import('@/views/system/partnerManagement/partner.vue'),
      name: 'partnerManage',
    },
    {
      path: '/system/partnerSave',
      component: () => import('@/views/system/partnerManagement/partnerSave.vue'),
      name: 'partnerSave'
    },
    {
      path: '/system/partnerEdit',
      component: () => import('@/views/system/partnerManagement/partnerEdit.vue'),
      name: 'partnerEdit'
    },
    {
      path: '/system/enquiredManage',
      component: () => import('@/views/system/enquiredManagement/enquired.vue'),
      name: 'enquiredManage',
    },
    {
      path: '/system/enquiredSave',
      component: () => import('@/views/system/enquiredManagement/enquiredSave.vue'),
      name: 'enquiredSave'
    },
    {
      path: '/system/enquiredEdit',
      component: () => import('@/views/system/enquiredManagement/enquiredEdit.vue'),
      name: 'enquiredEdit'
    },
    {
      path: '/system/QAManage',
      component: () => import('@/views/system/QAManagement/QA.vue'),
      name: 'QAManage',
    },
    {
      path: '/system/ASManage',
      component: () => import('@/views/system/ASManagement/AS.vue'),//机构、机构服务管理
      name: 'ASManage',
    },
    {
      path: '/system/mylabel',
      component: () => import('@/views/system/home/mylabel.vue'),	//我的标引
      name: 'mylabel',
    }
    , {
      path: '/system/ipcTreeIndex',
      component: () => import('@/views/system/patentManage/ipcTreeIndex.vue'),
      name: 'ipcTreeIndex',
    },
    {
      path: '/system/patentListIndex',
      component: () => import('@/views/system/patentManage/patentListIndex.vue'),
      name: 'patentListIndex',
    },
    {
      path: '/system/patentSearchIndex',
      component: () => import('@/views/system/patentManage/patentSearchIndex.vue'),
      name: 'patentSearchIndex',
    },
    {
      path: '/patent/patentAdvanceListIndex',
      component: () => import('@/views/system/patentManage/patentAdvanceListIndex.vue'),
      name: 'patentAdvanceListIndex',
    },
    {
      path: '/patent/patentIPCListIndex',
      component: () => import('@/views/system/patentManage/patentIPCListIndex.vue'),
      name: 'patentIPCListIndex',
    },
    {
      path: '/system/syshome',
      component: () => import('@/views/system/home'),
      name: 'syshome'
    },
    {
      path: '/system/userListIndex',
      component: () => import('@/views/system/home/userListIndex.vue'),
      name: 'userListIndex'
    },
    {
      path: '/system/navSetIndex',
      component: () => import('@/views/system/patentManage/navSetIndex.vue'),
      name: 'navSetIndex'
    },
		{
		  path: '/system/unionmember',
		  component: () => import('@/views/system/unionmember'),		//联盟成员
		  name: 'unionmember'
		},
		{
		  path: '/system/nmemberedit',
		  component: () => import('@/views/system/unionmember/save.vue'),		//联盟成员
		  name: 'nmemberedit'
		},
    {
      path: '/system/code',
      component: () => import('@/views/system/codeManage/code.vue'),
      name: 'code'
    },
    {
      path: '/system/loginlog',
      component: () => import('@/views/system/logs/loginlog.vue'),
      name: 'loginlog'
    },
    {
      path: '/system/busylog',
      component: () => import('@/views/system/logs/busylog.vue'),
      name: 'busylog'
    },
    {
      path: '/system/errlog',
      component: () => import('@/views/system/logs/errlog.vue'),
      name: 'errlog'
    },
    {
      path: '/system/dataupdate',
      component: () => import('@/views/system/dataUpdate'),
      name: 'dataupdate'
    },
    {
      path: '/system/applyline',
      name: 'applyline',
      component: () => import('@/views/patent/analysis/applyLine.vue') // 专利申请趋势分析
    },
    {
      path: '/system/pubLine',
      name: 'pubLine',
      component: () => import('@/views/patent/analysis/pubLine.vue') // 专利公开趋势分析
    },
    {
      path: '/system/applyandpubLine',
      name: 'applyandpubLine',
      component: () => import('@/views/patent/analysis/applyAndPubLine.vue') // 专利申请公开趋势分析
    },
    {
      path: '/system/pubrateline',
      name: 'pubrateline',
      component: () => import('@/views/patent/analysis/pubRateLine.vue') // 公开数量增长率
    },
    {
      path: '/system/ipcbar',
      name: 'ipcbar',
      component: () => import('@/views/patent/analysis/ipcBar.vue') // 技术构成
    },
    {
      path: '/system/ipcoverlapbar',
      name: 'ipcoverlapbar',
      component: () => import('@/views/patent/analysis/ipcOverlapBar.vue') // 技术全球分布
    },
    {
      path: '/system/ipccityBar',
      name: 'ipccityBar',
      component: () => import('@/views/patent/analysis/ipcCityBar.vue') // 技术中国省市分布
    },
    {
      path: '/system/ipccity2Bar',
      name: 'ipccity2Bar',
      component: () => import('@/views/patent/analysis/ipcCity2Bar.vue') // 技术中国城市分布
    },
    {
      path: '/system/apppeopletopbar',
      name: 'apppeopletopbar',
      component: () => import('@/views/patent/analysis/apppeopleTopBa.vue') // 申请人排名
    },
    {
      path: '/system/apppeopletypebar',
      name: 'apppeopletypebar',
      component: () => import('@/views/patent/analysis/apppeopleTypeBar.vue') // 申请人专利类别
    }
  ]
}
]

export default routes


// WEBPACK FOOTER //
// ./src/router/index.js